module.exports = __webpack_public_path__ + "static/media/vegetarian.d0247ba7.png";